module.exports = __webpack_public_path__ + "img/lead-services.2f520361.svg";